<div style="height:calc(100vh - 235px);">
    <dx-pie-chart #logsChart
                  id="pie"
                  palette="material"
                  resolveLabelOverlapping="shift"
                  type="pie"
                  [dataSource]="dataSource"
                  [title]="fileTransferName">
        <dxo-legend horizontalAlignment="center" verticalAlignment="bottom"/>
        <dxo-export [enabled]="true"/>
        <dxi-series argumentField="eventType"
                valueField="count">
            <dxo-label [visible]="true" format="fixedPoint" position="outside" displayFormat="{argument}: {value}">
                <dxo-connector [visible]="true" [width]="1"/>
            </dxo-label>
        </dxi-series>
        <dxo-export [enabled]="true"/>
    </dx-pie-chart>
</div>